import Vue from 'vue';
import Rete from 'rete';

// import TextControl from './TextControl';
import SelectControl from './SelectControl';


export default class ModuleComponent extends Rete.Component {

	constructor() {
		super("Module");
		this.path = ["Module"];
		this.contextMenuName = "Module";
		this.module = {
			nodeType: 'module'
		}
	}

	builder(node) {

		// Listener is not actually required since we update list on any toggle event in the moduleSelector
		// Create a listener for changes in the list of module names
		// Vue.prototype.$eventHub.$on('updatedModuleNameList', (data) => {
		//  console.log(data);
		//  console.log(node)
		// 	// update options list
		// 	// TODO
		// }); 
	

		let listOfModuleNames = Vue.prototype.$globalSharedData.arrayOfNamesOfCurrentlyExistingModulesWithOutputNode;
	
		let optionsList = [];
		for (let i = 0; i < listOfModuleNames.length; i++){
			optionsList.push({
				text: listOfModuleNames[i],
				value: listOfModuleNames[i]
			})
		}

		let ctrl = new SelectControl(this.editor, 'module', false, optionsList);

		console.log('Change function', ctrl.component.methods);
	
		ctrl.component.methods.onChange = (newVal) => { // vorher: ctrl.component.methods.onChange
			// debugger; 
			console.log('ctrl', ctrl);
			console.log('newVal in ModuleComponent', newVal);
			console.log('onChange triggered; the selector got changed or a new node was added!');
			console.log('this', this) // 'this' is the ModuleComponent
			console.log('ctrl.component', ctrl.component); // VueSelectControl
			// debugger;
			console.log('node', node);
			this.updateModuleSockets(node);
			node.update();
		}

		// Vue.get(this.modules, moduleName, { data: {id: 'spurs@0.1.0', nodes: {}}});
		// let InputAmount = new SelectControl(this.editor, 'inputamount', false, [
		// 	{ text: '2', value: 2 },
		// 	{ text: '3', value: 3 },
		// 	{ text: '4', value: 4 },
		// 	{ text: '5', value: 5 },
		// 	{ text: '6', value: 6 },
		// 	{ text: '7', value: 7 },
		// 	{ text: '8', value: 8 },
		// ]);

		return node.addControl(ctrl);
		// .addControl(InputAmount);

	}
	
	async worker(node, inputs, outputs) {

/* 		console.log('module node inputs', inputs)
		console.log('module node', node)
		console.log('module node outputs', outputs) */

	}

	change(node, item) {
		node.data.module = item;
		this.editor.trigger('process');
	}
}
